<template>
  <b-form-checkbox
    v-model="filterParams.is_transferred"
    style="margin-top: 25px"
    switch
    @change="getDataList"
  >
    Banka Transferlerini Gizle
  </b-form-checkbox>
</template>
<script>
import {
  BFormCheckbox,
} from 'bootstrap-vue'

export default {
  name: 'IsTransferred',
  components: {
    BFormCheckbox,
  },
  props: {
    getDataList: {
      type: Function,
      required: true,
    },
  },
  computed: {
    filterParams() {
      return this.$store.getters['accountActivities/filterParams']
    },
  },
}
</script>
